import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Results } from 'js/assessment';
import Loader from 'cccisd-loader';
import { ProviderSelect } from '../../components/Filters';
import { loadProviders, setSelectedProvider } from '../../reducers/share';

const Fortress = window.cccisd.fortress;
const actingRole = Fortress.user.acting.role.handle;

const ResultsPage = props => {
    const [hideStudentNames, setHideStudentNames] = useState(false);
    const dispatch = useDispatch();
    const providers = useSelector(state => state.app.share.providers);
    const selectedProvider = useSelector(state => state.app.share.selectedProvider);
    const [loading, setLoading] = useState(false);

    const getSupervisorHideStudentsValue = () => {
        let res = false;
        let supervisorFieldValue = Fortress.user.acting.role_data.hideStudentNames;
        if (Number.isInteger(supervisorFieldValue)) {
            res = !!supervisorFieldValue;
        }
        return res;
    };

    useEffect(() => {
        let ignore = false;
        const loadData = async () => {
            await dispatch(loadProviders({ guId: null, role: actingRole })).then(res => {
                const providerToSet = props.location.state?.provider || res.data.roles.instructorList[0].pawn.pawnId;
                dispatch(setSelectedProvider(providerToSet));
            });
        };
        if (['supervisor'].includes(actingRole) && !ignore) {
            setLoading(true);
            setHideStudentNames(getSupervisorHideStudentsValue());
            loadData();
            setLoading(false);
        }
        return () => {
            ignore = true;
        };
    }, []);

    if (loading) {
        return <Loader loading />;
    }

    return (
        <div className="py-4">
            {['supervisor'].includes(actingRole) && (
                <div style={{ display: 'flex', gap: '1em' }}>
                    <ProviderSelect providers={providers} />
                </div>
            )}
            {/* providerHandle is used for the Results query (supports instructor and orgInstructor handles)
                This should be updated in the future to support orgInstructor
            */}
            <Results
                selectedProvider={Number(selectedProvider)}
                providerHandle="instructor"
                planId={props.location.state?.assignmentPlanId}
                hideStudentNames={hideStudentNames}
            />
        </div>
    );
};

export default ResultsPage;
